export default {
  section_title: 'Currency',
  label: 'Currency',
  tooltip:
    'The currency your prices, payouts and reports use. It is set for your partner account when it is created and cannot be changed here — contact support if it is wrong.',
  from_your_partner: 'From your partner',
  set_for_your_account: 'Set for your account',
};
